import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import randomstring from 'uuid/v4';

import { bindActionCreators } from 'redux';
import * as actions from '../../../../actions/api.form.actions';

import { TypeMultiCheckIcon } from '../../../../images/icons/WrapSvg';
import MultiSelectInput from '../../../inputs/MultiSelectInput';

import Task from './Task';

class Multiselection extends React.Component {
    state = {
        valor: [],
        comment: '',
        point: 0,
        correction: 0,
        message: undefined,
        intervalId: undefined,
        desactivado: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { data, parentDeactivated, instance } = props;
        if (data !== state.data || parentDeactivated !== state.parentDeactivated) {
            const info =
                instance && instance.catalogos && instance.catalogos[data.catalogo]
                    ? instance.catalogos[data.catalogo]
                    : {};
            state.valores =
                info && info.valores
                    ? info.valores
                          .sort((a, b) => (a.orden > b.orden ? 1 : -1))
                          .map((f) => {
                              return { label: f.valor, value: f.id };
                          })
                    : [];
            state.valor = data.valor
                ? data.valor.split(',').map((i) => {
                      return state.valores.find((x) => x.value.toString() === i.toString());
                  })
                : [];
            state.desactivado = data.desactivado;
            state.parentDeactivated = parentDeactivated;
            state.data = data;
            return state;
        }
        return null;
    }


   handleChange(items, { action, removedValue }) {

        if (items && (!this.state.data.modoTest || action !== 'remove-value')) {
            const valores = items.map((f) => f.value);
            const elements = items.map((f) => {
                return { label: f.label, value: f.value, key: randomstring() };
            });
            this.props.setValue(this.state.data.codigo, valores.join(','), '', false, {});
            this.setState({ valor: elements });
        }
    }

    handleDeactive = (data, checked) => {
        this.props.setValue(data.codigo, undefined, '', checked, {});
        this.setState({ desactivado: checked, valor: [] });
    };

    render() {
        const { data, last, intl, editable } = this.props;
        const { valor, desactivado, parentDeactivated, valores } = this.state;
        const component = (
            <MultiSelectInput
                defaultValue={valor}
                placeHolder={intl.formatMessage({
                    id: 'multioptions_field_label',
                })}
                options={valores}
                onChange={this.handleChange.bind(this)}
                extraClass={data.modoTest ? 'select__multi-noremove' : ''}
            />
        );

        return (
            <Task
                key={data.codigo}
                data={data}
                editable={editable}
                value={valor.filter((f) => f)}
                icon={<TypeMultiCheckIcon color="primary" />}
                text="type_label_multioption"
                last={last}
                component={component}
                ignoreModoTest={true}
                desactivado={desactivado || parentDeactivated}
                parentDeactivated={parentDeactivated}
                onDeactive={this.handleDeactive}
            />
        );
    }
}

Multiselection.propTypes = {
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, actions), dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(injectIntl(Multiselection));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Multiselection.js